import * as z from "zod";

export const contactFormValuesSchema = z.object({
  message: z.string().nonempty(),
});

export type ContactForm = z.infer<typeof contactFormValuesSchema>;
